// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Tüm alt aktiviteler için zaman günlükleri',
    ActivityChildrenEstimatedHours_Text: 'Tüm alt aktiviteler için tahmini saat:',
    ActivityOwnBudget_Text: 'Aktivite Bütçesi:',
    ActivityOwnEstimatedHours_Text: 'Aktivite için tahmini saat:',
    ActivitySubactivitiesBudget_Text: 'Tüm Alt Faaliyetler Bütçesi :',
    ActualCompletion_Text: 'Gerçek tamamlanma',
    AddUser_Text: 'Kullanıcı davet et',
    BudgetedCost_Text: 'Bütçe Maliyeti:',
    BudgetTotal_Text: 'Bütçe , toplam :',
    Cancel: 'İptal',
    Close: 'Kapat',
    Cost_Text: 'Faturalandırma:',
    CustomerLabel: 'Müşteri',
    Duration_Text: 'Süre',
    EditProjectMembers_Title: 'Proje üyeleri',
    EditTaskAssignees_Title: 'Vekiller',
    End_Text: 'Son',
    EndDate_Text: 'Bitiş tarihi',
    EstimatedHours_Text: 'Tahmini saat:',
    EstimatedHours_Total_Text: 'Tahmini saat, toplam:',
    HoursLeftLabel: 'Saat kaldı :',
    InternalCost_Text: 'Dahili Maliyet:',
    OwnActualHours_Text: 'Aktivite için zaman günlükleri :',
    PlannedExpenses_Text: 'Planlanan Giderler:',
    PortfolioLabel: 'Portföy',
    Progress: 'ilerleme',
    ProjectChildrenActualHours_Text: 'Aktiviteler için zaman günlükleri:',
    ProjectChildrenEstimatedHours_Text: 'Tüm aktiviteler için tahmini saatler:',
    ProjectMembers_Text: 'Proje üyeleri',
    ProjectOwnBudget_Text: 'Proje Bütçesi :',
    ProjectOwnEstimatedHours_Text: 'Proje için tahmini saat:',
    ProjectSubactivitiesBudget_Text: 'Tüm faaliyetleri için bütçe:',
    Start_Text: 'Başla',
    StartDate_Text: 'Başlangıç Tarihi',
    Teams_Text: 'Takımlar',
    Untitled: 'Adsız',
    Validation_ActComplDateRange: 'Gerçek tamamlanma tarihi beklenen aralığına girmemektedir.',
    Validation_DateMandatory: 'Tarihi gerekli bir alandır .',
    Validation_EndDateRange: 'Bitiş tarihi beklenen aralığa girmemektedir.',
    Validation_FieldMandatory: 'Bu alan gereklidir.',
    Validation_Interger: 'Değer tamsayı olmalıdır.',
    Validation_InvalidDate: 'Tarihi \'{0}\' biçiminde olmalıdır.',
    Validation_NumberRange: 'Değer {0} ve {1} arasında olmalıdır',
    Validation_WeekendOrVacation: 'Değer haftasonu veya tatile denk gelmemelidir.',
};
